import { gql } from '@apollo/client';

const GET_FOUR_COLUMNS_ROUNDED_IMG_BY_SLUG = gql`
  query GetSectionBySlug($slug: String!) {
    sectionsBy(slug: $slug) {
      fourcolumnsrounded {
        linkFc {
          title
          url
        }
        tituloFcr
        images {
          image1 {
            contenido
            titulo
            imagen {
              node {
                mediaItemUrl
                title
              }
            }
          }
          image2 {
            contenido
            titulo
            imagen {
              node {
                mediaItemUrl
                title
              }
            }
          }
          image3 {
            contenido
            titulo
            imagen {
              node {
                mediaItemUrl
                title
              }
            }
          }
          image4 {
            contenido
            titulo
            imagen {
              node {
                mediaItemUrl
                title
              }
            }
          }
        }
      }
    }
  }
`;

export { GET_FOUR_COLUMNS_ROUNDED_IMG_BY_SLUG }